<template>
  <v-container fluid>
    <v-card flat class="px-3">
      <div class="mb-2 mt-2 pa-0 d-flex justify-space-between">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Tên mẫu"
          single-line
          hide-details
          outlined
          dense
          class="mb-4"
          style="max-width: 300px"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="openDialog" class="text-uppercase elevation-0">
          <v-icon left>mdi-plus</v-icon>
          Thêm mẫu mới
        </v-btn>
      </div>

      <v-alert type="info" outlined dense color="primary" class="mb-6">
        Lưu ý: Mẫu đánh giá sẽ được áp dụng khi thời khóa biểu của một lớp được sắp xếp. Khi đó, hệ thống sẽ tự động xóa
        các đánh giá cũ và tạo các đánh giá mới dựa trên mẫu này. Điều này đảm bảo rằng các đánh giá luôn phản ánh lịch
        học mới nhất của lớp.
      </v-alert>

      <v-card-text class="pa-0">
        <v-card class="elevation-0 mb-4" outlined>
          <v-data-table
            :headers="headers"
            :items="evaluateTemplates"
            :loading="loading"
            :search="search"
            :items-per-page="10"
            class="elevation-0 border"
            no-data-text="Không tìm thấy mẫu nào"
            :footer-props="{
              itemsPerPageText: 'Số dòng mỗi trang',
            }"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ item.type === 'session' ? 'Theo buổi' : item.type }}
            </template>
            <template v-slot:[`item.evaluate_criteria`]="{ item }">
              <v-chip v-for="criteria in item.evaluate_criteria" :key="criteria._id" class="mr-2 mb-2" small outlined>
                {{ criteria.title }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)" text>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Chỉnh sửa</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="deleteItem(item)" text>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Xóa</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>

    <evaluate-template-dialog
      v-model="dialog"
      :title="formTitle"
      :item="editedItem"
      @save="saveItem"
    ></evaluate-template-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EvaluateTemplateDialog from './DialogEvaluateTemplate.vue'

export default {
  components: {
    EvaluateTemplateDialog,
  },
  data: () => ({
    dialog: false,
    search: '',
    headers: [
      { text: 'Tên mẫu', align: 'start', value: 'name' },
      { text: 'Loại mẫu', align: 'start', value: 'type' },
      { text: 'Tiêu chí đánh giá', align: 'start', value: 'evaluate_criteria' },
      { text: 'Thao tác', value: 'actions', sortable: false, align: 'center' },
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      type: 'session',
      evaluate_criteria: [],
    },
    defaultItem: {
      id: '',
      name: '',
      type: 'session',
      evaluate_criteria: [],
    },
  }),

  computed: {
    ...mapState('evaluateTemplate', ['evaluateTemplates', 'loading']),
    formTitle() {
      return this.editedIndex === -1 ? 'Thêm mẫu mới' : 'Chỉnh sửa mẫu'
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    ...mapActions('evaluateTemplate', [
      'fetchEvaluateTemplates',
      'createEvaluateTemplate',
      'updateEvaluateTemplate',
      'deleteEvaluateTemplate',
    ]),
    ...mapActions('evaluateCriteria', ['fetchEvaluateCriterias']),

    initialize() {
      this.fetchEvaluateTemplates()
      this.fetchEvaluateCriterias()
    },

    editItem(item) {
      this.editedIndex = this.evaluateTemplates.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      if (confirm('Bạn có chắc chắn muốn xóa mẫu này?')) {
        this.deleteEvaluateTemplate(item.id)
      }
    },

    saveItem(item) {
      if (this.editedIndex > -1) {
        this.updateEvaluateTemplate({ id: item.id, data: item })
      } else {
        this.createEvaluateTemplate(item)
      }
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    openDialog() {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.dialog = true
    },
  },
}
</script>
